@if (ready_page < 2) {
  <div class="spinner-container">
    <app-load-spinner></app-load-spinner>
  </div>
} @else if (pantallaEnviar) {
  @if (!dataError) {
    <form (ngSubmit)="onSubmit()" #formulario [formGroup]="soporteForm">
      <p class="subtitle-text">
        Envianos un mail a
        <a class="email-link"> atentic&#64;cuatroplus.com </a>
        o completa el siguiente formulario y nuestro equipo de especialistas te
        dará soporte:
      </p>
      <div class="input-mat">
        <label for="asunto" [innerHTML]="'Asunto'"></label>
        <app-input-field-material
          [formControl]="asunto"
          [disabled]="soporteForm.get('asunto').disabled"
          (valueChanged)="onInputAsunto($event)"
          [errorInput]="
            asunto.hasError('required')
              ? 'Ingrese el asunto'
              : asunto.hasError('maxlength')
                ? 'Máximo 100 caracteres'
                : ''
          "
          placeholder="Escribe un título para tu consulta">
        </app-input-field-material>
      </div>
      <div class="input-mat">
        <label for="descripcion" [innerHTML]="'Descripción'"></label>
        <app-text-area-material
          [formControl]="descripcion"
          [disabled]="soporteForm.get('descripcion').disabled"
          (valueChanged)="onInputDescripcion($event)"
          [errorInput]="
            descripcion.hasError('required')
              ? 'Ingrese la descripción'
              : descripcion.hasError('maxlength')
                ? 'Máximo 1000 caracteres'
                : ''
          "
          placeholder="Escribe una descripción para tu consulta">
        </app-text-area-material>
      </div>
      <div class="input-mat">
        <label for="nombre" [innerHTML]="'Nombre del solicitante'"></label>
        <app-input-field-material
          [formControl]="nombre"
          [disabled]="soporteForm.get('nombre').disabled"
          (valueChanged)="onInputNombre($event)"
          [errorInput]="
            nombre.hasError('required')
              ? 'Ingrese su nombre'
              : nombre.hasError('maxlength')
                ? 'Máximo 100 caracteres'
                : ''
          "
          placeholder="Escribe tu nombre">
        </app-input-field-material>
      </div>
      <div class="input-mat">
        <label for="mail" [innerHTML]="'Mail de contacto'"></label>
        <label
          for="mail"
          class="input-label2"
          [innerHTML]="
            'A este mail te enviaremos la respuesta sobre tu consulta.'
          "></label>
        <app-input-field-material
          [formControl]="mail"
          [disabled]="soporteForm.get('mail').disabled"
          (valueChanged)="onInputMail($event)"
          [errorInput]="
            mail.hasError('required')
              ? 'Ingrese su mail'
              : mail.hasError('maxlength')
                ? 'Máximo 100 caracteres'
                : mail.hasError('invalidEmail') && mail.touched
                  ? 'Formato de correo inválido'
                  : ''
          "
          placeholder="Escribe tu mail">
        </app-input-field-material>
      </div>
      <footer class="footer">
        <div class="footer-section">
          <span class="material-symbols-rounded">quiz</span>
          <p class="footer-text">
            ¿No quieres esperar? Obtén respuestas en el instante con nuestros
            Instructivos y Preguntas Frecuentes:
            <a
              href=" https://cuatroplus.atlassian.net/wiki/x/9YBf"
              target="_blank"
              class="email-link">
              Ir a Asistencia 4PIoT
            </a>
          </p>
        </div>
      </footer>
    </form>
  } @else {
    <app-data-error (reintentar)="ngOnInit()"></app-data-error>
  }
} @else {
  <div class="recived-message">
    <span class="material-symbols-rounded icon-size">mark_email_read</span>
    <div class="div-textos">
      <app-titulo titulo="¡Consulta enviada con éxito!"></app-titulo>
      <p class="textos-body-medium title-text">
        Tu número de Ticket es
        <a class="textos-title-small"> {{ issuekey }}.</a><br />
        Puedes ingresar al ticket clickeando en el siguiente enlace:
      </p>
      <!-- <a class="email-link">
      cuatroplus.atlassian.net/servicedesk/customer/portal/2/A4PIOT-45
    </a> -->
      <a [href]="link" target="_blank" class="email-link">
        {{ link }}
      </a>
      <p class="textos-title-small message-ticket">
        Pero no te preocupes, ¡no tienes que hacer nada! <br />
        Te enviaremos la respuesta a directamente en tu mail
        {{ soporteForm.get('mail').value }}
      </p>
    </div>
  </div>
}
